import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { IconButton, Chip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
export default function MuiSelect({ items, handleChange, value, label }) {
  const [selected, setSelected] = React.useState(value || "");

  const handleValueChange = (event) => {
    const selectedValue = event.target.value;
    setSelected(selectedValue); // Update selected value state
    handleChange(selectedValue); // Call the passed handleChange if needed
  };

  const handleClearSelection = () => {
    setSelected(""); // Clear the selected value
    handleChange(""); // Call the passed handleChange to clear the value
  };

  return (
    <Box sx={{width:'50%'}} >
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          size="small"
          fullWidth
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selected} // Set the selected state as the value of the Select
          label={label}
          onChange={handleValueChange} // Handle change of value
        >
          {items?.map((item, index) => (
            <MenuItem value={item?.value || item?.name} key={index}>
              {item?.name}
            </MenuItem>
          ))}
        </Select>

        {/* Clear Icon with rounded chip design */}
        {selected && (
          <Chip
            icon={<ClearIcon />}
            onClick={handleClearSelection}
            size="small"
            label="Clear"
            style={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: "50%",
              backgroundColor: "#f1f1f1", // Light background color for the chip
              cursor: "pointer",
            }}
          />
        )}
      </FormControl>
    </Box>
  );
}
